/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import React, { useState, useEffect, useContext } from "react";
import CircularProgressWithLabel from "../../../components/CircularProgressWithLabel";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import styles from "../dashboard.module.scss";
import { getDocCount } from "../../../services/apiservices/counters";
import { COLLECTIONS } from "../../../services/config";
import AuthContext from "../../../hooks/authContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCube } from "@fortawesome/free-solid-svg-icons";

function EmpRequests(props) {
  const auth = useContext(AuthContext);
  const [progress, setProgress] = useState(0);
  const [empReqData, setEmpReqData] = useState([]);
  const [empTotal, setEmpTotal] = useState(0);
  const [empUrg, setEmpUrg] = useState(0);
  const [status, setStatus] = useState("Supplies");
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const statusList = [
    { label: "Supplies", value: "Supplies" },
    { label: "Clothing", value: "Clothing" },
  ];

  const onChangeInput = (e) => {
    setStatus(e.target.value);
  };

  const updateProgress = (newval) => {
    setProgress(newval);
  };

  useEffect(() => {
    getDocCount(
      COLLECTIONS.SUPPLIES_ORDER,
      (res) => {
        const details = res.filter(
          (item) => item.companyId === companyId && item.archive !== true
        );
        setEmpReqData(details);

        // Calculate progress
        const urgentreq = details.filter((item) => item.priority === "1");
        if (res.length) {
          updateProgress((100 / res.length) * urgentreq.length);
        } else {
          updateProgress(0);
        }
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
  }, []);

  useEffect(() => {
    let filteredData = [];
    if (status === "Clothing") {
    filteredData = empReqData.filter(
      (record) =>
        record.supplyItems.some((item) => item.maxNumberAllowed !== undefined) &&
        !["Delivered", "Rejected"].includes(record.status)
      );
    } else if (status === "Supplies") {
      filteredData = empReqData.filter(
        (record) =>
          record.supplyItems.every((item) => !item.hasOwnProperty("maxNumberAllowed")) &&
          !["Delivered", "Rejected"].includes(record.status)
      );
    }


    const urgentRequests = filteredData?.filter((item) => item.priority === "1")?.length;
    const openRequests = filteredData?.length;

    setEmpUrg(urgentRequests);
    setEmpTotal(openRequests);
    const progressValue = openRequests ? (urgentRequests / openRequests) * 100 : 0;
    setProgress(progressValue);
  }, [status, empReqData]);

  return (
    <>
      <Grid item xs={12} sm={7} lg={12} className="mb-20">
        <div className="d-flex flex-center mb-10">
          <FontAwesomeIcon
            size="xl"
            icon={faCube}
            style={{
              color: "#f59e0b",
            }}
          />
          <p className="p-0 m-0 ml-10 fonthe dark:text-white">Employee Requests</p>
        </div>
        <div style={{ marginBottom:"10px",width:"100%", border:"1px solid #E2E8F0"}}></div>
        <SingleSelect
          value={status}
          className={`field newonr`}
          name={"status"}
          onChange={(e) => onChangeInput(e)}
          options={statusList}
        />
      </Grid>
      <ul>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Open Requests
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{empTotal}</strong>
            </Grid>
          </Grid>
        </li>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Urgent Request
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{empUrg}</strong>
            </Grid>
          </Grid>
        </li>
      </ul>

      <Grid item xs={12} sm={5} lg={12} style={{marginTop:"42px"}}>
        <CircularProgressWithLabel
          signt={"yes"}
          value={progress}
          wrapclass="#f9bc0a"
          title={"Urgent Request Ratio"}
        />
      </Grid>
    </>
  );
}

export default EmpRequests;
